import { defineAsyncComponent } from "vue";
import { availabeRole } from "@/helpers/access";

export default {
  forms: {
    edit: {
      panel: {
        width: "50%",
      },
      component: defineAsyncComponent(() => import("./forms/Edit.vue")),
    },
    list: {
      config: {
        actions: {
          edit: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          create: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          copy: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          delete: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
        },
        fields: {
          id: {
            config: {
              visible: false,
            },
          },
          name: {},
        },
      },
    },
    select: {
      panel: {
        width: "30%",
      },
      config: {
        sorting: true,
        actions: {
          view: true,
          edit: false,
          create: false,
          copy: false,
          delete: false,
        },
        fields: {
          id: {
            config: {
              visible: false,
            },
          },
          name: {
            config: {
              sorting: "floors.name",
            },
          },
        },
      },
    },
  },
};
